import { ChannelSettingsDropdownComponent } from '@components/channel-settings-dropdown/channel-settings-dropdown.component';
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { ChannelTableRowComponent } from '@components/channel-table-row/channel-table-row.component';
import { AlarmAnimationService } from '@service/alarm-animation.service';
import { DeviceFlagsService } from '@service/device-flags.service';
import { ResponsiveService } from '@service/responsive.service';
import { Channel, ChannelFns } from 'ops/common/models/channel';

@Component({
    selector: 'app-channel-table-row-wrap',
    templateUrl: './channel-table-row-wrap.component.html',
    styleUrls: [
        './channel-table-row-wrap.component.scss',
        '../alarm-table-row-wrap/alarm-table-row-wrap.component.scss',
    ],
    standalone: false,
})
export class ChannelTableRowWrapComponent
    extends ChannelTableRowComponent
    implements OnChanges, OnInit, OnDestroy
{
    @Input() isSelectedChannel: boolean;

    @Output() selectChannel = new EventEmitter();
    @Output() onSubmit = new EventEmitter<Channel>();
    @Output() onCloseClicked = new EventEmitter<Channel>();
    @Output() onAdvancedSettings = new EventEmitter<Channel>();
    @Output() onDeleteAlarm = new EventEmitter<Channel>();
    @Output() onInitScroll = new EventEmitter<HTMLElement>();

    @ViewChild('channelWrap', { static: true })
    channelWrap: ElementRef;

    @ViewChild('ChannelSettingsDropDown')
    ChannelSettingsDropDown: ChannelSettingsDropdownComponent;

    selected: boolean = false;
    disabled: boolean = false;

    alarmStateToTextClassMap = new Map();
    alarmStateToBorderMap = new Map();
    alarmStateTextMap = new Map();
    statusText: string = '';

    alarmTextClass = 'text-gap';

    constructor(
        flagService: DeviceFlagsService,
        alarmAnimation: AlarmAnimationService,
        responsive: ResponsiveService,
        cdr: ChangeDetectorRef,
    ) {
        super(flagService, alarmAnimation, responsive, cdr);
    }

    ngOnInit(): void {
        this.disabled = ChannelFns.isChannelBlank(this.channel);
        this.isDigital = ChannelFns.isDigital(this.channel);
        this.measurementUnit = this.channel.opsData.measurementUnit;
        this.flagsSubscription = this.flagService.onAllFlagsUpdated().subscribe(() => {
            this.channelValue = this.flagService.getFlags(this.channel)?.value;
            this.ngClass = this.alarmAnimation.getAlarmClasses(this.channel);
            this.updateStatusString();
            this.cdr.markForCheck();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isSelectedChannel && this.isSelectedChannel && this.channelWrap) {
            this.onInitScroll.emit(this.channelWrap.nativeElement);
        }
    }

    ngOnDestroy(): void {
        this.flagsSubscription?.unsubscribe();
    }

    onChannelSelect() {
        this.selected = true;
        this.selectChannel.emit(this.channel);
    }

    onSubmitEmit(event) {
        this.onSubmit.emit(event);
    }

    onCloseClickedEmit() {
        this.onCloseClicked.emit();
    }

    onAdvancedSettingsEmit(event: Channel) {
        this.onAdvancedSettings.emit(event);
    }

    onDeleteAlarmEmit(event: Channel) {
        this.onDeleteAlarm.emit(event);
    }

    closePreviewForm() {
        this.ChannelSettingsDropDown.closePreviewForm();
    }
}
